import { toggle } from 'slidetoggle';

type State = 'open' | 'closed';
type Animation = 'slide' | 'fade';

class Dropdown {
  private state: State = 'closed';
  private buttonSelector = '.js-dropdown-button';
  private contentSelector = '.js-dropdown-content';
  private containerEl: HTMLElement;
  private button: HTMLElement;
  private content: HTMLElement;

  constructor(
    container: string | HTMLElement,
    public animation: Animation = 'slide',
    public speed = 300
  ) {
    if (typeof container === 'string') {
      this.containerEl = document.querySelector(container);
    } else {
      this.containerEl = container;
    }

    if (this.containerEl) {
      this.init();
      this.setState('closed');
    }
  }

  //  Open dropdown content
  open(): void {
    this.setState('open');
    if (this.animation === 'slide') this.slideToggle();

    if (this.animation === 'fade') this.containerEl.classList.add('fade-in');
  }

  //  Close dropdown content
  close(): void {
    this.setState('closed');
    if (this.animation === 'slide') this.slideToggle();

    if (this.animation === 'fade') this.containerEl.classList.remove('fade-in');
  }

  //  Toggle dropdown content
  toggle(): void {
    if (this.state === 'open') {
      this.close();
    } else {
      this.open();
    }
  }

  get getState(): State {
    return this.state;
  }

  //  Initial dropdown events and esentials setup
  private init(): void {
    this.button = this.containerEl.querySelector(this.buttonSelector);
    this.content = this.containerEl.querySelector(this.contentSelector);

    if (this.button && this.content) {
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    if (this.animation === 'fade') {
      this.containerEl.classList.add('fade-animation');
    }
  }

  //  Change dropdown state
  private setState(state: State) {
    this.state = state;
    this.containerEl.dataset.dropdownState = state;
  }

  //  Slide content with transition
  private slideToggle(): void {
    toggle(this.content, {
      miliseconds: this.speed,
      transitionFunction: 'ease-in-out'
    });
  }
}

export default Dropdown;
